import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router';

// Association
const AboutPage = lazy(() =>
  import('@pages/Portal/Association/AboutPage').then((m) => ({
    default: m.AboutPage,
  }))
);

const BoardMembersPage = lazy(() =>
  import('@pages/Portal/Association/BoardMembersPage').then((m) => ({
    default: m.BoardMembersPage,
  }))
);

const DisciplinesPage = lazy(() =>
  import('@pages/Portal/Association/DisciplinesPage').then((m) => ({
    default: m.DisciplinesPage,
  }))
);

const FormsPage = lazy(() =>
  import('@pages/Portal/Association/FormsPage').then((m) => ({
    default: m.FormsPage,
  }))
);

const IdeaBoxPage = lazy(() =>
  import('@pages/Portal/Association/IdeaBoxPage').then((m) => ({
    default: m.IdeaBoxPage,
  }))
);

const TimelinePage = lazy(() =>
  import('@pages/Portal/Association/Timeline').then((m) => ({
    default: m.TimelinePage,
  }))
);

// Instructions
const InstructionsOverview = lazy(() =>
  import('@pages/Portal/Association/instructions/InstructionsOverview').then(
    (m) => ({
      default: m.InstructionsOverview,
    })
  )
);

const InstructionPage = lazy(() =>
  import('@pages/Portal/Association/instructions/InstructionPage').then(
    (m) => ({
      default: m.InstructionPage,
    })
  )
);

// Rules & Regulations
const RulesAndRegulationsPage = lazy(() =>
  import('@pages/Portal/Association/rules-and-regulations/RulesAndRegulationsPage').then(
    (m) => ({
      default: m.RulesAndRegulationsPage,
    })
  )
);

const RulesAndRegulationsOverview = lazy(() =>
  import('@pages/Portal/Association/rules-and-regulations/RulesAndRegulationsOverview').then(
    (m) => ({
      default: m.RulesAndRegulationsOverview,
    })
  )
);

export const portalAssociationRoutes = (
  <Route path="association">
    <Route index element={<Navigate to="about" replace />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="board-members" element={<BoardMembersPage />} />
    <Route path="disciplines" element={<DisciplinesPage />} />
    <Route path="forms" element={<FormsPage />} />

    <Route path="instructions">
      <Route index element={<InstructionsOverview />} />
      <Route path=":slug" element={<InstructionPage />} />
    </Route>

    <Route path="regulations-and-safety">
      <Route index element={<RulesAndRegulationsOverview />} />
      <Route path=":slug" element={<RulesAndRegulationsPage />} />
    </Route>

    <Route path="timeline" element={<TimelinePage />} />
    <Route path="ideas" element={<IdeaBoxPage />} />
  </Route>
);
